var map = {
	"./Group 2167.svg": 58,
	"./gallery-1.jpg": 59,
	"./gallery-2.jpg": 60,
	"./gallery-3.jpg": 61,
	"./gallery-new-1.jpg": 62,
	"./gallery-new-2.jpg": 63,
	"./gallery-new-3.jpg": 64,
	"./gallery-new-4.jpg": 65,
	"./store_enriching.jpg": 66,
	"./store_fasttrack.jpg": 67,
	"./store_mentorship.jpg": 68,
	"./store_ownership.jpg": 69,
	"./video-bg.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;